var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function Story(el) {
  var $el = $(el),
      $content = $el.find('.story__content');

  $content.find('iframe, object, embed').parent().not('.resumator-form-iframe').addClass('embed-responsive');
}

module.exports = Story;
